import { useIzteachSessionStore } from '../stores/izteach';
import { useQltAuthStore } from '../stores/qlt';

// the one teardown sequence; AuthGate sends the user to /login as soon as jwt clears
export function useSignOut(): () => void {
  const signOut = useQltAuthStore((state) => state.signOut);
  const clearIzteach = useIzteachSessionStore((state) => state.clear);
  return () => {
    clearIzteach();
    signOut();
  };
}
